
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { SiteEventGetHeatmapCollection, SiteEventGetHeatmapCollectionResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<SiteEventGetHeatmapCollectionResponse, SiteEventGetHeatmapCollectionResponse>) => response?.data?.weightedHeatmapLocations;
const getError = (response?: SWRResponse<SiteEventGetHeatmapCollectionResponse, SiteEventGetHeatmapCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<SiteEventGetHeatmapCollectionResponse, SiteEventGetHeatmapCollectionResponse>) => ({});

const useGetMapHeatmap = (query?: Partial<SiteEventGetHeatmapCollection>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new SiteEventGetHeatmapCollection(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetMapHeatmap;